import { render, staticRenderFns } from "./big-data-list.vue?vue&type=template&id=2b1c1a68&"
import script from "./big-data-list.vue?vue&type=script&lang=js&"
export * from "./big-data-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports